<div class="user-box" [ngClass]="{ 'show-menu': showMenu }" (click)="openMenu($event)">
  <div class="credentials">
    <div class="nickname">{{ profile?.name }} {{ profile?.surname }}</div>
    <div class="upercase">{{ profile?.role }}</div>
  </div>
  <div class="pic-wrapper" *ngIf="profile?.picture">
    <img class="picture" [src]="profile?.picture" [alt]="profile?.name" />
  </div>
  <div class="menu-wrapper tricking"></div>
</div>